import { useState } from 'react';

const stats = [
  { label: '高清资源', value: '10万+' },
  { label: '每日更新', value: '200+' },
  { label: '流畅不卡', value: '99.9%' },
];

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 md:pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50 to-background-100/60"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>今日已更新 200+ 影视资源</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              蓝莓影院
              <span className="block text-primary-600 text-lg md:text-2xl lg:text-3xl mt-2 font-sans font-medium">
                高清免费在线观影平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              全网热播电视剧、最新电影大片一网打尽，全部高清片源即点即看。蓝莓影院每日人工精选更新，
              不缓冲、不收费、不卡顿，给您最纯粹的在线观影体验。
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              当前热播《苍穹之刃》《暗夜追光者》等话题大作正在连载中，更有经典高分影片专区随时回顾。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="font-heading text-xl md:text-2xl text-primary-600">{s.value}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 font-medium rounded-full hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm no-underline"
              >
                <i className="ri-information-line text-lg"></i>
                了解本站特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            {!imgError ? (
              <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20with%20soft%20amber%20spotlight%20on%20a%20dark%20theater%20stage%2C%20elegant%20velvet%20curtains%20in%20deep%20coral%20tones%20partially%20drawn%2C%20floating%20film%20reels%20and%20golden%20popcorn%20scattered%20artistically%2C%20warm%20atmospheric%20glow%20with%20subtle%20lens%20flares%2C%20luxurious%20and%20inviting%20mood%2C%203D%20render%20style%20with%20rich%20textures%20and%20dramatic%20lighting%20composition&width=960&height=720&seq=hero-cinema-main&orientation=landscape"
                  alt="蓝莓影院高清在线观影平台主视觉"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
              </div>
            ) : (
              <div className="w-full max-w-[480px] aspect-[4/3] rounded-2xl bg-background-100 flex items-center justify-center">
                <i className="ri-movie-2-line text-5xl text-foreground-300"></i>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}